import {Component} from '@angular/core';
import {AppService, StoreSelectorsService} from "../../../../services";
import {AccountVersion, IBaseBlockComponent, IUser} from "../../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {isGalaxy} from "../../../../common";
import {Lib} from "../../../../../libs/Lib";

@Component({
    selector: 'app-block-pop',
    templateUrl: './block-pop.component.html',
    styleUrls: ['./block-pop.component.scss'],
    standalone: false
})
export class BlockPopComponent extends BlockBaseComponent implements IBaseBlockComponent {

    m_user: IUser;
    enabled: boolean;

    constructor(private translocoService: TranslocoService,
                private appService: AppService,
                public override storeSelector: StoreSelectorsService) {
        super(storeSelector);
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                    this.enabled = Lib.IsAccountSubscribingAndActive(this.m_user);
                })
        );
    }

    override preInit() {
        super.preInit();
    }

    override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
        super.initApplyStoreToDynamic(applyStoreToDynamic);
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
    }

    override componentInit() {
        super.componentInit();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.enabled', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "enabled",
                disabled: !this.enabled,
                ignoreMissingValue: true,
                storePath: 'Data[0].Stat[0].$.enabled'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.tag', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                restrictChar: 'alphanums',
                name: "tag",
                storePath: 'Data[0].Stat[0].$.tag'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.field', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "field",
                storePath: 'Data[0].Stat[0].$.field'
            },
            // {
            //     type: "input",
            //     value: '',
            //     label: this.translocoService.translate('general.category', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "category",
            //     storePath: 'Data[0].Stat[0].$.category'
            // },
            {
                type: "input",
                minMaxDefault: '5',
                value: '30',
                step: '1',
                inputType: "number",
                label: 'minThreshold',
                name: "minThreshold",
                storePath: 'Data[0].Stat[0].$.minThreshold'
            },
            {
                type: "input",
                value: '30',
                step: '1',
                inputType: "number",
                label: 'maxThreshold',
                name: "maxThreshold",
                storePath: 'Data[0].Stat[0].$.maxThreshold'
            }
        ];
        this.toggleField();
    }

    toggleField() {
        if (this.sceneItem.$.player === '4300' || this.sceneItem.$.player === '4305') {
            this.setUiConfigHide('field', false);
        } else {
            this.setUiConfigHide('field', true);
        }
    }

    override componentStoreUpdates() {
        this.toggleField();
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }

    override submit(formValues) {
        super.submit(formValues);
    }
}

